import en_transcript from './lang/en.json';
import ar_transcript from './lang/ar.json';
import he_transcript from './lang/he.json';
import en_flag from './images/flags/en.svg';
import ar_flag from './images/flags/ar.svg';
import he_flag from './images/flags/he.svg';

export const getLanguages = () => {
    return [
        {
            name: 'English',
            label: 'Eng',
            locale: 'en',
            image: en_flag,
            direction: 'ltr'
        },
        {
            name: 'עִברִית',
            label: 'Heb',
            locale: 'he',
            image: he_flag,
            direction: 'rtl'
        }
    ];
}

export const getLocale = () => {
    let locale = localStorage.getItem('locale');

    if (!locale) {
        locale = 'en';
    }

    return locale;
}

export const setLocale = (locale) => {
    localStorage.setItem('locale', locale);
}

export const trans = (key) => {
    const locale = getLocale();
    const transcript = {
        en: en_transcript,
        ar: ar_transcript,
        he: he_transcript,
    }

    if (transcript[locale]) {
        if (transcript[locale][key]) {
            return transcript[locale][key];
        }
    }

    return key;
}